module.exports = __webpack_public_path__ + "img/banner.fa08f2d3.png";